import { FC } from 'react'
import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import styles from './AIPlannerTypography.module.css'

interface AIPlannerMarkdownRendererProps {
  content: string
  className?: string
}

const aiPlannerComponents = {
  h1: ({ children }: any) => <h1 className={styles.h1}>{children}</h1>,
  h2: ({ children }: any) => <h2 className={styles.h2}>{children}</h2>,
  h3: ({ children }: any) => <h3 className={styles.h3}>{children}</h3>,
  h4: ({ children }: any) => <h4 className={styles.h3}>{children}</h4>,
  h5: ({ children }: any) => <h5 className={styles.h3}>{children}</h5>,
  h6: ({ children }: any) => <h6 className={styles.h3}>{children}</h6>,
  p: ({ children }: any) => <p className={styles.paragraph}>{children}</p>,
  strong: ({ children }: any) => <strong>{children}</strong>,
  em: ({ children }: any) => <em>{children}</em>,
  ul: ({ children }: any) => <ul className={styles.unorderedList}>{children}</ul>,
  ol: ({ children }: any) => <ol className={styles.orderedList}>{children}</ol>,
  li: ({ children }: any) => <li className={styles.listItem}>{children}</li>,
  blockquote: ({ children }: any) => <blockquote className={styles.blockquote}>{children}</blockquote>,
  hr: () => <hr className={styles.horizontalRule} />,
  code: ({ children }: any) => <code className={styles.inlineCode}>{children}</code>,
  pre: ({ children }: any) => <pre className={styles.codeBlock}>{children}</pre>,
  table: ({ children }: any) => <table className={styles.table}>{children}</table>,
  thead: ({ children }: any) => <thead className={styles.thead}>{children}</thead>,
  th: ({ children }: any) => <th className={styles.th}>{children}</th>,
  td: ({ children }: any) => <td className={styles.td}>{children}</td>
}

const AIPlannerMarkdownRenderer: FC<AIPlannerMarkdownRendererProps> = ({ content, className }) => {
  const wrapperClasses = [styles.aiPlannerRoot, className].filter(Boolean).join(' ')

  return (
    <div className={wrapperClasses}>
      <Markdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw, rehypeSanitize]}
        components={aiPlannerComponents}
      >
        {content}
      </Markdown>
    </div>
  )
}

export default AIPlannerMarkdownRenderer
